// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingResponse_container__k_5St"};